import React from 'react'
import PropTypes from 'prop-types'
import Typography from '../Typography'
import classes from './senior-package-instructions.module.sass'

const SeniorPackageInstructions = ({ title, subtitle }) => (
  <Typography align="center" weight="bold" classes={classes.topText}>
    {title}
    {subtitle && <Typography tag="span" align="center" weight="normal">{subtitle}</Typography>}
  </Typography>
)

SeniorPackageInstructions.defaultProps = {
  subtitle: '',
}

SeniorPackageInstructions.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
}

export default SeniorPackageInstructions
